import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, LoginBox, Input, Button } from "../styles/LoginStyles";
import { login } from "../services/api";

const Login = () => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(password);
      setPassword("");
      navigate("/dashboard", { replace: true });
    } catch (requestError) {
      setError(requestError.response?.data?.error || "Não foi possível entrar. Verifique a conexão.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <LoginBox>
        <h2>Login</h2>
        <form onSubmit={handleLogin}>
        <Input
          type="password"
          autoComplete="current-password"
          placeholder="Digite a senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <p role="alert" style={{ color: "#b42318" }}>{error}</p>}
        <Button type="submit" disabled={loading || !password}>
          {loading ? "Entrando..." : "Entrar"}
        </Button>
        </form>
      </LoginBox>
    </Container>
  );
};

export default Login;


